'use client';

import type { AnalyticsPort, AnalyticsValue } from '@/core/ports/analytics';

declare global {
  interface Window {
    umami?: {
      track?: (event?: string, data?: Record<string, AnalyticsValue>) => void;
    };
  }
}

export const umamiAnalytics: AnalyticsPort = {
  pageView: () => {
    if (typeof window === 'undefined') return;
    if (!isAnalyticsAllowed()) return;
    window.umami?.track?.();
  },
  track: (event, properties) => {
    if (typeof window === 'undefined') return;
    if (!isAnalyticsAllowed()) return;
    window.umami?.track?.(event, properties);
  },
  identify: () => {},
};

function isAnalyticsAllowed() {
  if (typeof document === 'undefined') return true;
  const cookies = document.cookie.split(';').map((cookie) => cookie.trim());
  const declined = cookies.some((cookie) => cookie.startsWith('analytics_consent=declined'));
  const optOut = cookies.some((cookie) => cookie.startsWith('ccpa_opt_out=1'));
  return !declined && !optOut;
}
